import { useFormContext } from 'react-hook-form'
import { ReactNode } from 'react'
import { FlexColumn, FlexRow } from '../../../atoms/layout/Flex'
import Label from '../../../atoms/display/Label'
import TextField from '../../../atoms/inputs/TextField'
import Divider from '../../../atoms/display/Divider'
import CheckboxControl from '../../../atoms/inputs/CheckboxControl'
import { VisitorRegistrationFormParams } from '../../../../types/Company'

function FormRow(props: { text: string; subText?: string; children: ReactNode }) {
  const { text, subText, children } = props
  return (
    <FlexColumn>
      <FlexRow align="center">
        <FlexColumn width={120} space={0}>
          <Label text={text} />
          {subText && <Label text={subText} variant="caption" />}
        </FlexColumn>
        {children}
      </FlexRow>
      <Divider />
    </FlexColumn>
  )
}

export default function VisitorRegistrationQualificationsForm() {
  const form = useFormContext<VisitorRegistrationFormParams>()
  const { errors } = form.formState

  return (
    <FlexColumn>
      <Label text="事業所全体の保有資格について" variant="subtitle" />
      <FormRow text="国家資格">
        <FlexColumn space={0}>
          <FlexRow space={0} wrap>
            <CheckboxControl control={form.control} name="qualificationA1" label="1級建築士" />
            <CheckboxControl control={form.control} name="qualificationA2" label="2級建築士" />
            <CheckboxControl control={form.control} name="qualificationA3" label="木造建築士" />
            <CheckboxControl control={form.control} name="qualificationA4" label="1級施工管理技士" />
            <CheckboxControl control={form.control} name="qualificationA5" label="2級施工管理技士" />
            <CheckboxControl control={form.control} name="qualificationA6" label="1級塗装" />
            <CheckboxControl control={form.control} name="qualificationA7" label="1種電気" />
            <CheckboxControl control={form.control} name="qualificationA8" label="2種電気" />
          </FlexRow>
          <FlexRow align="flex-start">
            <FlexRow width={100}>
              <CheckboxControl control={form.control} name="qualificationAOther" label="その他" />
            </FlexRow>
            <FlexRow width={480}>
              <TextField
                register={form.register('qualificationAOtherText')}
                error={errors.qualificationAOtherText?.message}
              />
            </FlexRow>
          </FlexRow>
        </FlexColumn>
      </FormRow>
      <FormRow text="技能講習" subText="作業主任者">
        <FlexColumn space={0}>
          <FlexRow space={0} wrap>
            <CheckboxControl control={form.control} name="qualificationB1" label="足場の組立て等" />
            <CheckboxControl control={form.control} name="qualificationB2" label="有機溶剤" />
            <CheckboxControl control={form.control} name="qualificationB3" label="石綿" />
            <CheckboxControl control={form.control} name="qualificationB4" label="酸素欠乏危険" />
            <CheckboxControl control={form.control} name="qualificationB5" label="土止め支保工" />
            <CheckboxControl control={form.control} name="qualificationB6" label="地山掘削" />
            <CheckboxControl control={form.control} name="qualificationB7" label="玉掛け" />
            <CheckboxControl control={form.control} name="qualificationB8" label="コンクリート破砕" />
          </FlexRow>
          <FlexRow align="flex-start">
            <FlexRow width={100}>
              <CheckboxControl control={form.control} name="qualificationBOther" label="その他" />
            </FlexRow>
            <FlexRow width={480}>
              <TextField
                register={form.register('qualificationBOtherText')}
                error={errors.qualificationBOtherText?.message}
              />
            </FlexRow>
          </FlexRow>
        </FlexColumn>
      </FormRow>
      <FormRow text="技能講習" subText="運転者">
        <FlexColumn space={0}>
          <FlexRow space={0} wrap>
            <CheckboxControl control={form.control} name="qualificationC1" label="車両系建設機械（3t以上）" />
            <CheckboxControl control={form.control} name="qualificationC2" label="小型移動式クレーン（1t以上5t未満）" />
            <CheckboxControl control={form.control} name="qualificationC3" label="フォークリフト（1t以上）" />
          </FlexRow>
          <FlexRow align="flex-start">
            <FlexRow width={100}>
              <CheckboxControl control={form.control} name="qualificationCOther" label="その他" />
            </FlexRow>
            <FlexRow width={480}>
              <TextField
                register={form.register('qualificationCOtherText')}
                error={errors.qualificationCOtherText?.message}
              />
            </FlexRow>
          </FlexRow>
        </FlexColumn>
      </FormRow>
      <FormRow text="特別教育" subText="作業者・運転者">
        <FlexColumn space={0}>
          <FlexRow space={0} wrap>
            <CheckboxControl control={form.control} name="qualificationD1" label="足場組立従者" />
            <CheckboxControl control={form.control} name="qualificationD2" label="フルハーネス型墜落制止用器具" />
            <CheckboxControl control={form.control} name="qualificationD3" label="石綿作業従事者" />
            <CheckboxControl control={form.control} name="qualificationD4" label="玉掛け（1t未満）" />
            <CheckboxControl control={form.control} name="qualificationD5" label="自由研削といし（グライダー）" />
            <CheckboxControl control={form.control} name="qualificationD6" label="丸のこ等取扱い作業" />
            <CheckboxControl control={form.control} name="qualificationD7" label="フォークリフト（1t未満）" />
            <CheckboxControl control={form.control} name="qualificationD8" label="小型車両系建設機械（3t未満）" />
            <CheckboxControl control={form.control} name="qualificationD9" label="巻上げ機運転（ウインチ）" />
          </FlexRow>
          <FlexRow align="flex-start">
            <FlexRow width={100}>
              <CheckboxControl control={form.control} name="qualificationDOther" label="その他" />
            </FlexRow>
            <FlexRow width={480}>
              <TextField
                register={form.register('qualificationDOtherText')}
                error={errors.qualificationDOtherText?.message}
              />
            </FlexRow>
          </FlexRow>
        </FlexColumn>
      </FormRow>
    </FlexColumn>
  )
}
